// HOAD Story com Scroll: enquanto a seção fica presa na tela (sticky), o
// scroll troca qual capítulo está visível (fade + leve zoom), como um passe
// de mágica — um capítulo some, o próximo aparece no lugar. Sem lib externa,
// sem scroll-jacking (o navegador continua controlando o scroll, só mudamos
// classes com base na posição). Desliga sozinho pra quem pediu menos
// movimento no sistema (ver o fallback estático no CSS).
(function () {
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  // Abaixo de 1024px o CSS já empilha os capítulos estáticos (21/09 — sticky
  // + fade não sobrava espaço pro texto no celular, ver hoad-scroll-story.css).
  // Sem isso o listener de scroll continuava rodando à toa em todo frame no
  // mobile, sem efeito nenhum (CSS já força opacity:1 fora do .is-active).
  var isMobile = window.matchMedia && window.matchMedia('(max-width: 1023px)').matches;

  function setup(root) {
    var track = root.querySelector('[data-hoad-story-track]');
    var chapters = root.querySelectorAll('[data-hoad-story-chapter]');
    var fill = root.querySelector('[data-hoad-story-progress-fill]');
    if (!track || !chapters.length) return;

    if (reduceMotion || isMobile) {
      return; // CSS já mostra todo capítulo empilhado, nada pra JS dirigir.
    }

    var activeIndex = 0;
    var ticking = false;

    function update() {
      ticking = false;
      var rect = track.getBoundingClientRect();
      var viewportHeight = window.innerHeight || document.documentElement.clientHeight;
      var total = rect.height - viewportHeight;

      var progress = 0;
      if (total > 0) {
        progress = Math.min(1, Math.max(0, -rect.top / total));
      } else if (rect.top < 0) {
        progress = 1;
      }

      if (fill) {
        fill.style.height = (progress * 100) + '%';
      }

      var index = Math.min(chapters.length - 1, Math.floor(progress * chapters.length));
      if (index !== activeIndex || (index === 0 && progress === 0 && !chapters[0].classList.contains('is-active'))) {
        chapters[activeIndex].classList.remove('is-active');
        chapters[index].classList.add('is-active');
        activeIndex = index;
      }
    }

    function onScroll() {
      if (!ticking) {
        window.requestAnimationFrame(update);
        ticking = true;
      }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    update();
  }

  document.querySelectorAll('[data-hoad-scroll-story]').forEach(setup);
})();
